import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { COOKIE_LOCALE_OVERRIDE } from "@faire/web--source/common/consts/COOKIE_LOCALE_OVERRIDE";
import { removeCookie, setCookies } from "@faire/web--source/common/cookies";
import { Storage } from "@faire/web--source/common/Storage";
import patchUser from "@faire/web-api--source/api/user/patch";
import { localeKeyToLocaleString } from "./localeKeyToLocaleString";
var BROWSER_LOCALE_OVERRIDE_KEY = "IF_BROWSER_LOCALE_OVERRIDE";
export var setLocale = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(language, userToken, localeKey) {
        var newLocaleCookieValue;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    newLocaleCookieValue = localeKey && localeKey.language ? localeKeyToLocaleString({
                        localeKey: localeKey
                    }) : localeKeyToLocaleString({
                        localeKey: {
                            language: language,
                            country: undefined
                        }
                    });
                    setCookies(COOKIE_LOCALE_OVERRIDE, newLocaleCookieValue);
                    if (!userToken) return [
                        3,
                        4
                    ];
                    if (!localeKey) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        patchUser({
                            token: userToken,
                            locale_key: localeKey
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        patchUser({
                            token: userToken,
                            language: language
                        })
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    Storage.local.setItem(BROWSER_LOCALE_OVERRIDE_KEY, newLocaleCookieValue);
                    return [
                        2
                    ];
            }
        });
    });
    return function setLocale(language, userToken, localeKey) {
        return _ref.apply(this, arguments);
    };
}();
export var setLocaleForCookie = function(language, cookie, localeKey) {
    var newLocaleCookieValue = localeKey && localeKey.language ? localeKeyToLocaleString({
        localeKey: localeKey
    }) : localeKeyToLocaleString({
        localeKey: {
            language: language,
            country: undefined
        }
    });
    setCookies(cookie, newLocaleCookieValue);
};
export var clearLocaleOverrides = function() {
    removeCookie(COOKIE_LOCALE_OVERRIDE);
    Storage.local.removeItem(BROWSER_LOCALE_OVERRIDE_KEY);
};
